import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useLangUrl } from '../../utilities/useLangUrl';
// import Cookies from 'js-cookie';

const AdminBooksContext = createContext();

export function AdminBooksProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [settingBooks, setSettingBooks] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [downloading, setDownloading] = useState(false);
    const [booksLimit, setBooksLimit] = useState(999);

    const langUrl = useLangUrl();

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchBooks() {
            setLoading(true);
            try {

                // library/books?page=1&limit=20&categoryId=2
                const booksData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/library/books?${searchQuery ? "" : `page=${currentPage}&limit=${booksLimit}`}&${selectedCategory ? `categoryId=${selectedCategory}&` : ""}`);

                setSettingBooks(booksData);
            } catch (err) {
                setSettingBooks(null);

            } finally {
                setLoading(false);
            }
        }
        fetchBooks();
    }, [navigate, currentPage, selectedCategory, searchQuery, langUrl, booksLimit, downloading]);


    return (
        <AdminBooksContext.Provider
            value={{
                loading, setLoading, selectedCategory, setSelectedCategory,
                settingBooks, setSettingBooks, currentPage, setCurrentPage,
                searchQuery, setSearchQuery, booksLimit, setBooksLimit,
                downloading, setDownloading
            }}>
            {children}
        </AdminBooksContext.Provider>
    );
}

export function useAdminBooks() {
    return useContext(AdminBooksContext);
}